export type LogoutHandlerProps = {
    children: React.ReactNode;
}

export const LogoutHandler = (props: LogoutHandlerProps) => {
    return <form method='POST' action="/api/user/logout">
        {props.children}
    </form>
}